import * as React from 'react';

import type {DistributionBarSection} from './types';

import styles from './distribution-bar.module.css';

type Props = {
    sections: DistributionBarSection[];
};

export function EqualWidthMode(props: Props) {
    return (
        <div className={styles['distribution-bar-container']}>
            {props.sections.map((section) => (
                <div
                    key={section.label}
                    style={{backgroundColor: section.color}}
                    className={styles['bar-section-equal']}
                >
                    <div
                        className='flex flex-dir-col align-center'
                        style={{color: section.labelColor}}
                    >
                        <span className='font-bold'>{section.value}</span>
                        {section.label}
                    </div>
                </div>
            ))}
        </div>
    );
}
